'use strict';

/**
 *
 * @param startPoint 启动坐标
 * @param endPoint 终点坐标
 * @param angle 夹角
 * @param arrowLen 箭头长度
 */
exports.getArrowPoint = function (startPoint, endPoint, arrowAngle, arrowLen) {

  var lineAngle;
  var angleC;
  var angleA;
  var rimA;
  var rimB;
  var rimC;
  var leftArrowAngle;
  var rightArrowAngle;


  lineAngle = 0;
  if (endPoint.x - startPoint.x !== 0) {
    lineAngle = Math.atan((endPoint.y - startPoint.y) / (endPoint.x - startPoint.x));
  } else {
    if (endPoint.y - startPoint.y < 0) {
      lineAngle = Math.PI / 2;
    } else {
      lineAngle = 3 * Math.PI / 2;
    }
  }

  if ((endPoint.y - startPoint.y >= 0) && (endPoint.x - startPoint.x <= 0)) {
    lineAngle = lineAngle + Math.PI;
  } else if ((endPoint.y - startPoint.y <= 0) && (endPoint.x - startPoint.x <= 0)) {
    lineAngle = lineAngle + Math.PI;
  }

  angleC = arrowAngle;
  rimA = arrowLen;
  rimB = Math.pow(Math.pow(endPoint.y - startPoint.y, 2) + Math.pow(endPoint.x - startPoint.x, 2), 0.5);
  rimC = Math.pow(Math.pow(rimA, 2) + Math.pow(rimB, 2) - 2 * rimA * rimB * Math.cos(angleC), 0.5);

  angleA = Math.acos((rimB - rimA * Math.cos(angleC)) / rimC);

  leftArrowAngle = lineAngle + angleA;
  rightArrowAngle = lineAngle - angleA;

  return {
    left: {
      x: Math.round(startPoint.x + rimC * Math.cos(leftArrowAngle)),
      y: Math.round(startPoint.y + rimC * Math.sin(leftArrowAngle))
    },
    right: {
      x: Math.round(startPoint.x + rimC * Math.cos(rightArrowAngle)),
      y: Math.round(startPoint.y + rimC * Math.sin(rightArrowAngle))
    }
  };
};


/** WEBPACK FOOTER **
 ** ./src/helper/arrowHelper.js
 **/